import script from "./Show.vue?vue&type=script&lang=ts&setup=true"
export * from "./Show.vue?vue&type=script&lang=ts&setup=true"

import "./Show.vue?vue&type=style&index=0&id=54ed9789&lang=css"

const __exports__ = script;

export default __exports__